export const PAYMENT_METHOD_OPTIONS = [
  { label: "Cash", value: "CASH" },
  { label: "Bank Transfer", value: "BANK_TRANSFER" },
  { label: "Cheque", value: "CHEQUE" },
  { label: "Credit Card", value: "CREDIT_CARD" },
  { label: "Electronic Transfer", value: "ELECTRONIC_TRANSFER" },
  { label: "UPI", value: "UPI" },
  { label: "PayPal", value: "PAYPAL" },
];

export const STATUS_CHIP = {
  PENDING_VERIFICATION: { label: "Pending", color: "warning" },
  VERIFIED: { label: "Verified", color: "success" },
  REJECTED: { label: "Rejected", color: "error" },
};

export const PRIMARY_CHARGE_LABELS = {
  VISA: "Visa charge",
  INSURANCE: "Insurance price",
  RPL_CLIENT: "Cost",
  SKILL_ASSESSMENT: "Government fee",
};

/** RPL has always required a method on a new payment; the other modules leave it optional. */
export const requiresPaymentMethod = (moduleType) => moduleType === "RPL_CLIENT";
